import gsap from 'gsap'
import lottieWeb from 'lottie-web'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

import * as dat from 'dat.gui'

export const initNewYearsBanner = (canvas) => {

	if (!canvas) return

	/* Debug */
	const gui = new dat.GUI({ width: 400 })
	gui.hide()

	/* Scene */
	const scene = new THREE.Scene()

	/* Model */
	let model
	const loader = new GLTFLoader()
	loader.load('./dist/models/nye-cube-model.glb', function (gltf) {
		model = gltf.scene
		scene.add(model)

		model.position.set(0, 0, 0)
		model.rotation.set(0, 0, 0)
		model.scale.set(1, 1, 1)

		gui.add(model.position, 'x').name('Model Position X')
		gui.add(model.position, 'y').name('Model Position Y')
		gui.add(model.position, 'z').name('Model Position Z')

		gui.add(model.rotation, 'x').name('Model Rotation X')
		gui.add(model.rotation, 'y').name('Model Rotation Y')
		gui.add(model.rotation, 'z').name('Model Rotation Z')

	})

	/* Lights */
	const ambientLight = new THREE.AmbientLight(0xffffff, 3)
	scene.add(ambientLight)

	const directionalLight = new THREE.DirectionalLight(0xffffff, 0.6)
	directionalLight.castShadow = true
	directionalLight.shadow.mapSize.set(1024, 1024)
	directionalLight.shadow.camera.far = 15
	directionalLight.shadow.camera.left = -7
	directionalLight.shadow.camera.top = 7
	directionalLight.shadow.camera.right = 7
	directionalLight.shadow.camera.bottom = -7
	directionalLight.position.set(5, 5, 5)
	scene.add(directionalLight)

	const directionalLight2 = new THREE.DirectionalLight(0xffffff, 0.9)
	scene.add(directionalLight2)

	const pointLight = new THREE.PointLight(0xffffff, 40, 2)
	pointLight.position.set(0, 0.75, 3.5)
	pointLight.distance = 10
	scene.add(pointLight)

	const pointLight2 = new THREE.PointLight(0xffffff, 40, 2)
	pointLight2.position.set(0, 0.75, 3.5)
	pointLight2.distance = 10
	scene.add(pointLight2)

	gsap.fromTo(pointLight.position, {
		x: -10,
		y: 1
	}, {
		x: 10,
		y: -1,
		duration: 3,
		ease: 'power1.inOut',
		repeatDelay: 2,
		repeat: -1
	})

	gsap.fromTo(pointLight2.position, {
		x: -10,
		y: 1
	}, {
		x: 10,
		y: -1,
		duration: 3,
		ease: 'power1.inOut',
		delay: 0.5,
		repeatDelay: 2,
		repeat: -1
	})

	/* GridHelper */
	const size = 10
	const divisions = 10
	const gridHelper = new THREE.GridHelper(size, divisions)
	// scene.add(gridHelper)

	/* Sizes */
	// const sizes = {
	// 	width: canvas.parentElement.width,
	// 	height: canvas.parentElement.height
	// }
	const sizes = {
		width: window.innerWidth,
		height: window.innerHeight
	}
 
	window.addEventListener('resize', () => {
		// Update sizes
		sizes.width = window.innerWidth
		sizes.height = window.innerHeight
		// sizes.width = canvas.parentElement.width
		// sizes.height = canvas.parentElement.height

		// Update camera
		if (window.innerWidth < 650) {
			camera.position.set(5, 3.5, 12)
		} else if (window.innerWidth < 1024) {
			camera.position.set(5, 3.5, 8)
		} else {
			camera.position.set(5, 3.5, 4)
		}
		camera.aspect = sizes.width / sizes.height
		camera.updateProjectionMatrix()

		// Update renderer
		renderer.setSize(sizes.width, sizes.height)
		renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
	})

	/* Camera */
	const camera = new THREE.PerspectiveCamera(45, sizes.width / sizes.height, 1, 100)
	// camera.position.set(0, -1, 8) // Adjust Z value for distance from the object

	if (window.innerWidth < 650) {
		camera.position.set(5, 3.5, 12)
	} else if (window.innerWidth < 1024) {
		camera.position.set(5, 3.5, 8)
	} else {
		camera.position.set(5, 3.5, 4)
	}

	camera.rotation.set(0, 0, 0)
	scene.add(camera)
	gui.add(camera.position, 'x').name('Camera Position X')
	gui.add(camera.position, 'y').name('Camera Position Y')
	gui.add(camera.position, 'z').name('Camera Position Z')
	gui.add(camera.rotation, 'x').name('Camera Rotation X')
	gui.add(camera.rotation, 'y').name('Camera Rotation Y')
	gui.add(camera.rotation, 'z').name('Camera Rotation Z')

	gui.add(pointLight.position, 'x').name('pointLight Position X')
	gui.add(pointLight.position, 'y').name('pointLight Position Y')
	gui.add(pointLight.position, 'z').name('pointLight Position Z')
	// gui.add(pointLight.distance).name('pointLight Distance')

	/* Controls */
	const controls = new OrbitControls(camera, canvas)
	controls.target.set(0, 0.75, 0)
	controls.enableZoom = false 
	controls.enableDamping = true
	controls.enablePan = false

	/* Renderer */
	const renderer = new THREE.WebGLRenderer({
		canvas: canvas,
		alpha: true
	})

	renderer.shadowMap.enabled = true
	renderer.shadowMap.type = THREE.PCFSoftShadowMap
	renderer.setSize(sizes.width, sizes.height)
	renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

	const moveModelWithMouse = (event) => {
		const mouseX = event.clientX - window.innerWidth / 2
		const mouseY = event.clientY - window.innerHeight / 2

		gsap.to(camera.position, { duration: 0.6, y: mouseY / 300 + 3 })
		gsap.to(model.rotation, { duration: 0.6, y: mouseX / 2000 })
	}

	document.addEventListener('mousemove', moveModelWithMouse)

	/* Animate */
	const clock = new THREE.Clock()
	let previousTime = 0

	const tick = () => {
		const elapsedTime = clock.getElapsedTime()
		const deltaTime = elapsedTime - previousTime
		previousTime = elapsedTime

		// Update controls
		controls.update()

		// Render
		renderer.render(scene, camera)

		if (model && window.innerWidth < 650) {
			model.rotation.y -= 0.005; 
		}

		// Call tick again on the next frame
		window.requestAnimationFrame(tick)
	}

	tick()

	const sparklesAnimation = () => {
		const container = document.querySelector('.nye-banner__sparkles')
    const animation = lottieWeb.loadAnimation({ 
      container: container,
      autoplay: true,
      renderer: 'svg',
      loop: true,
      path: '/lottie/sparkles.json'
    })
	}

	sparklesAnimation()
}

export const newYearsBanner = () => {

	const canvases = document.querySelectorAll('canvas#nye-canvas')

	canvases.forEach(canvas => {
		initNewYearsBanner(canvas)
	})
}

export default () => {}
